import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const selectedDate_state = {};
export const selectedDateValue = createReducer(selectedDate_state, {
  [types.SELECTED_DATE](state, action) {
    let newState = selectedDate_state;
    newState = action.value;
    return newState;
  }
});

const x = {};
export const selectedHoursValue = createReducer(x, {
  [types.SELECTED_HOURS](state, action) {
    let newState = x;
    newState = action.value;
    return newState;
  }
});
